export const StatusEnum = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  SUSPENDED: "SUSPENDED",
  CANCELLED: "CANCELLED",
  PENDING: "PENDING",
}

export enum StatusTranslatedEnum {
  ACTIVE= "Actif",
  INACTIVE= "Inactif",
  SUSPENDED= "Suspendu",
  CANCELLED= "Annulé",
  PENDING= "En attente",
  "on_time" = "A jour",
  late = "En retard",
  collection = "Recouvrement"
}

export enum PromoBaseEnum {
  TOTAL = "INVOICE_TOTAL_AMOUNT",
  PER_LINE = "INVOICE_LINE_ITEM"
}

export enum PromoTypeEnum {
  PERCENTAGE="PERCENTAGE",
  FIXED = "FIXED",
}

export enum PromoTypeTransEnum {
  PERCENTAGE="POURCENTAGE",
  FIXED="FIXE",
}

export enum ReductionStatusEnum {
  SUSPENDED = "SUSPENDED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const reductionBaseOptions = [
  {
    label: "Lignes individuelles de la facture",
    // description: "Indiquez que la réduction s'effectue sur le prix par collaborateur.",
    value: PromoBaseEnum.PER_LINE,
  },
  {
    label: "Total de la facture",
    // description: "Indiquez que la réduction s'effectue sur le montant total de la facture.",
    value: PromoBaseEnum.TOTAL,
  },
];
export const reductionTypeOptions = [
  {
    label: "Pourcentage",
    value: PromoTypeEnum.PERCENTAGE,
  },
  {
    label: "Montant fixe",
    value: PromoTypeEnum.FIXED,
  },
];

export const PERIODICITIES = [
  {
    label: "Mensuel",
    value: 1,
  },
  {
    label: "Bimensuel",
    value: 2,
  },
  {
    label: "Trimestriel",
    value: 3,
  },
  // {
  //   label: "Quadrimestriel",
  //   value: 4,
  // },
  // {
  //   label: "Tous les 5 mois",
  //   value: 5,
  // },
  {
    label: "Semestriel",
    value: 6,
  },
  // {
  //   label: "Tous les 7 mois",
  //   value: 7,
  // },
  // {
  //   label: "Tous les 8 mois",
  //   value: 8,
  // },
  // {
  //   label: "Tous les 9 mois",
  //   value: 9,
  // },
  // {
  //   label: "Tous les 10 mois",
  //   value: 10,
  // },
  // {
  //   label: "Tous les 11 mois",
  //   value: 11,
  // },
  {
    label: "Annuel",
    value: 12,
  },
]

export const PERIODICITYNAMES = PERIODICITIES.map((periodic) => (periodic.label))

// MONTHLY = 1
// BIMONTHLY = 2
// QUARTERLY = 3
// FOUR_MONTHLY = 4
// FIVE_MONTHLY = 5
// BIANNUAL = 6
// SEVEN_MONTHLY = 7
// EIGHT_MONTHLY = 8
// NINE_MONTHLY = 9
// TEN_MONTHLY = 10
// ELEVEN_MONTHLY = 11
// ANNUAL = 12

//
// PERIODICITY_CHOICES = (
//   (MONTHLY, "Mensuel"),
//     (BIMONTHLY, "Bimensuel"),
//     (QUARTERLY, "Trimestriel"),
//     (FOUR_MONTHLY, "Quadrimestriel"),
//     (FIVE_MONTHLY, "Tous les 5 mois"),
//     (BIANNUAL, "Semestriel"),
//     (SEVEN_MONTHLY, "Tous les 7 mois"),
//     (EIGHT_MONTHLY, "Tous les 8 mois"),
//     (NINE_MONTHLY, "Tous les 9 mois"),
//     (TEN_MONTHLY, "Tous les 10 mois"),
//     (ELEVEN_MONTHLY, "Tous les 11 mois"),
//     (ANNUAL, "Annuel"),
// )